import Dropdown from "./modules/Dropdown";

function init() {
  document.querySelectorAll('.dropdown').forEach(item => {
    if (item instanceof HTMLElement) {
      new Dropdown(item);
    }
  });
}

window.addEventListener('load', init, false);
